import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgFeatureFlagsModule } from '@principle-theorem/ng-feature-flags';
import { NgInteractionsModule } from '@principle-theorem/ng-interactions';
import { ManagementToolPanelComponent } from '@principle-theorem/ng-management-tools';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import {
  NgPrincipleModule,
  RecallsService,
  SetupStepBannerComponent,
} from '@principle-theorem/ng-principle';
import {
  NgPrincipleSharedModule,
  PracticeMohSettingsComponent,
} from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { BrandsModule } from './brands/brands.module';
import { PracticesModule } from './practices/practices.module';
import { SecurityComponent } from './security/security.component';
import { UserRestrictionFormComponent } from './security/user-restriction-form/user-restriction-form.component';
import { SettingsSplashComponent } from './settings-splash/settings-splash.component';
import { SettingsComponent } from './settings.component';

@NgModule({
  declarations: [SettingsComponent, SettingsSplashComponent, SecurityComponent],
  imports: [
    NgPrincipleSharedModule,
    NgPrincipleModule,
    NgSharedModule,
    NgMaterialModule,
    NgFeatureFlagsModule,
    RouterModule,
    PracticesModule,
    BrandsModule,
    PracticeMohSettingsComponent,
    NgInteractionsModule,
    ManagementToolPanelComponent,
    SetupStepBannerComponent,
    UserRestrictionFormComponent,
  ],
  providers: [RecallsService],
})
export class SettingsPagesModule {}
